import React from 'react'
import Flag from '../assets/flag.svg'

interface BlogCardProps {
  image: string
  title: string
  readTime: string
  category: string
  onClick: () => void
}

const BlogCard: React.FC<BlogCardProps> = ({
  image,
  title,
  readTime,
  category,
  onClick,
}) => {
  return (
    <div 
      className='bg-[#F1F1F6] rounded-2xl overflow-hidden cursor-pointer hover:shadow-lg transition-shadow duration-300'
      onClick={onClick}
    >
      {/* Image Container */}
      <div className='relative'>
        {image && image !== '/src/assets/placeholder-two.svg' ? (
          <img
            src={image}
            alt={title}
            className='w-full h-48 object-cover rounded-br-[16px] rounded-bl-[16px]'
          />
        ) : (
          <div className='w-full h-48 bg-gradient-to-br from-[#001B38] to-[#002a50] rounded-br-[16px] rounded-bl-[16px] flex items-center justify-center'>
            <div className='text-white text-2xl font-bold opacity-50'>{category}</div>
          </div>
        )}
        {/* Insights Badge */}
        <div className='absolute top-4 left-4'>
          <div className='bg-white rounded-[12px] px-3 py-1 flex items-center space-x-2 shadow-sm'>
            <div className='w-[46px] h-[30px] bg-[#FEE4E2] rounded-[10px] flex items-center justify-center'>
              <img src={Flag} alt='Flag' />
            </div>
            <span className='text-sm font-medium text-gray-700 text-start'>
              {category}
            </span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className='p-6'>
        <h3 className='text-lg font-semibold text-gray-900 mb-4 leading-tight text-start'>
          {title}
        </h3>

        {/* Footer */}
        <div className='flex items-center justify-between'>
          <div className='flex items-center space-x-2'>
            <div className='w-1 h-1 bg-red-500 rounded-full'></div>
            <span className='text-sm text-gray-600'>{readTime}</span>
          </div>
          <button 
            onClick={(e) => {
              e.stopPropagation()
              onClick()
            }}
            className='text-sm font-medium text-gray-900 hover:text-red-500 transition-colors'
          >
            Read
          </button>
        </div>
      </div>
    </div>
  )
}

export default BlogCard
